import type { FunctionComponent } from 'react';
import { object, optional, boolean, string, Struct, func } from 'superstruct';

export const walletConfigSchema = object({
  showBenefitDetailFeedbackComponent: optional(boolean()),
  showLandingPageHeaderBranding: optional(boolean()),
  showBenefitStatusBannerCreated: optional(boolean()),
  showBenefitStatusBannerPending: optional(boolean()),
  showBenefitStatusBannerExpired: optional(boolean()),
  showLandingPageClaimsEntry: optional(boolean()),
  enableNoNetworkLiveBalances: optional(boolean()),
  typeformIds: optional(
    object({
      en: string(),
      es: string(),
      fr: string(),
    }),
  ),
  slots: optional(
    object({
      Banner: optional(func() as unknown as Struct<FunctionComponent>),
      PolicyDetails: optional(func() as unknown as Struct<FunctionComponent>),
    }),
  ),
});
